// Pure mapping from a hosted connection-health value ("ok"|"connecting"|"off",
// state.connHealth's vocabulary) to the .td-dot state class. Kept DOM-free in
// its own module so it is unit-testable and shared by every dropdown renderer.
export function dotStateClass(health) {
  if (health === "ok") return "connected";
  if (health === "connecting") return "connecting";
  return "off";
}
